<ng-template #TooltipContent>
  <div class="tooltip-content">
    <span *ngFor="let document of documents; let i = index"
      class="tooltip-item">{{ document | translate }}<span *ngIf="i < documents.length-1">,</span></span>
  </div>
</ng-template>

<div
  class="contact-counter"
  [tooltip]="TooltipContent"
  [theme]="'light'"
  content-type="template"
  [options]="{placement: 'right', noArrow: true}"
  >
  {{documents.length}}
</div>
